// Rarely Young product loader. Pulls /products.json, keeps Rarely Young
// products, and normalizes them for the page templates.
//
// A product is included if: handle is in DEPARTMENTS, Shopify tag is "kids",
// or vendor is an entire-brand kids maker. Department is handle override,
// else vendor default. New SKUs from Play/Adventure/Rest brands land on that
// sort without a theme edit. Mixed adult vendors (Rarely, Beaver Craft, etc.)
// need the kids tag. Fitwood is handle-only (Rest vs Adventure).
// A "christmas" tag also lists an already-included product on Christmas.
// It does not add a product by itself, and it does not pull it off Play /
// Adventure / Rest.
window.RarelyYoung = (function () {
  var DEPARTMENTS = {"35mm-wooden-balls-set-of-12-rubber-wood-non-toxic-color-finish":"Play","6-layer-cotton-muslin-baby-blanket-fern-print":"Rest","abel-golden-ratio-mini-blocks-24-piece-set":"Play","acacia-hardwood-toy-ship-40-x-14-x-35-cm-2":"Play","animal-baby-rabbit-organic-cotton-wool-beige":"Rest","apple-helene-top-with-spinning-rings-hand-turned-austrian-hardwood":"Play","avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy":"Rest","baby-rocker-for-ages-0-24-months-beech-eucalyptus-removable-muslin-cushion":"Rest","balls-rolling-rattle-beech-linden-lagoon":"Play","banwood-basket-pins-flower-recycled-rubber":"Adventure","banwood-first-go-balance-bike-cream-12-adjustable-37-44cm-saddle":"Adventure","banwood-kids-cruiser-skateboard-canadian-maple-ages-3":"Adventure","banwood-kids-helmet-matte-beige-50-54-cm":"Adventure","banwood-maxi-scooter-vintage-green-oak-deck-ages-6":"Adventure","banwood-pin-ride-basket-recycled-rubber-ivory":"Adventure","banwood-protective-gear-3-pack-ages-3":"Adventure","banwood-scooter-vintage-cream-3-wheel-oak-deck-ages-3":"Adventure","banwood-trike-steel-frame-vintage-finish-ages-3-6":"Adventure","baukje-exler-silhouette-print-golden-hour-toverlux-translucent":"Rest","baukje-exler-silhouette-winter-robin-toverlux-insert":"Rest","beach-collecting-kit-forceps-bottles-botanical-labels":"Adventure","beanbag-goose-stuffed-plush-toy":"Rest","bloom-butterfly-3d-organic-jacquard-knit-baby-blanket":"Rest","blueberries-for-sal-childrens-book-by-robert-mccloskey-64-pages":"Rest","bonbon-spinning-top-8-colors":"Play","bubbly-natural-round-washable-rug-honey-5-4-lbs":"Rest","bunny-buddies-organic-cotton-baby-blanket-30-x-42-jacquard-knit":"Rest","bunny-organic-jacquard-knit-baby-blanket-thick-n-thin":"Rest","bushcraft-boxed-set-by-dave-canterbury":"Adventure","charlie-farmhouse-knitted-plaid-blanket-cotton-baby-size":"Rest","charlie-farmhouse-quilted-play-mat":"Rest","chill-pink-bird-rocking-toy-hand-toy":"Play","classic-bedroom-dollhouse-set-1-12-scale-7-piece":"Play","classic-childrens-bedroom-dollhouse-furniture-set-1-12-scale-bunk-bed-table-chair-toy-chest":"Play","classic-dining-room-1-12-scale-dollhouse-furniture-set-plantoys":"Play","clementine-lemon-embroidered-knit-baby-blanket":"Rest","clouds-washable-kids-rug-vintage-blue-4-x-5-3":"Rest","cottontail-cottage-wooden-dollhouse-17-32-x-13-07-x-18-7":"Play","cuddly-animal-elephant-large-linen-heat-cushion":"Rest","cuddly-elephant-small-linen-senger-naturwelt":"Rest","dollhouse-furniture-set-1-12-scale-living-room-bedroom-kitchen-dining-room-bathroom":"Play","dove-white-classic-pointelle-knit-baby-blanket-organic-cotton":"Rest","elephant-organic-cotton-knit-stuffed-animal":"Rest","elephant-trail-organic-jacquard-knit-baby-blanket":"Rest","felt-pads-for-luoto-laakso-arches-birch-3-pack":"Adventure","fern-herbarium-journal-forest-green-recycled-materials":"Adventure","field-flower-press-refill-cardboard-10pcs":"Adventure","field-flower-press-reusable-botanical-press-made-in-usa":"Adventure","filana-organic-beeswax-block-crayons-12-classic-colors-made-with-20-certified-organic-beeswax":"Play","filana-organic-beeswax-block-crayons-12-skintones":"Play","filana-organic-beeswax-crayons-12-classic-colors-recycled-paper-box":"Play","filana-organic-beeswax-crayons-12-skin-tone-colors-stick-format":"Play","firerod-v2":"Adventure","firerod-v2-1":"Adventure","first-journey-play-set-wooden-lion-in-car-with-landscape-natural-beech-linden":"Play","floppy-animal-fox-senger-naturwelt":"Rest","floppy-bear-small-white-gots-certified-cotton-sheeps-wool":"Rest","floppy-cat-doll-small-grey":"Rest","floppy-rabbit-large-beige-sheeps-wool-fill":"Rest","floppy-rabbit-small-rose-sakura":"Rest","floppy-rabbit-small-white":"Rest","flower-press-refill-boards-10-pack":"Adventure","flower-rattle-beech-beeswax-natural":"Play","flowing-yellow-bird-hand-toy":"Play","giraffe-organic-cotton-jacquard-baby-blanket-30-x-42":"Rest","goodnight-moon-75th-anniversary-slipcase-edition-hardcover-with-afterword-art-print":"Rest","grabber-giraffe-beige-plaid":"Rest","grand-victorian-dollhouse-4-floor-rubberwood-24-76-x-13-19-x-28-03":"Play","great-kingdom-wooden-blocks-65-piece-set-linden-wood":"Play","handmade-baby-bear-white-6-5-plush":"Rest","handwoven-seagrass-hamper-24-x-19-x-13-amish-made":"Rest","handwoven-seagrass-laundry-basket-leather-handles-23-x-16-x-11":"Rest","heat-pad-goose-gray-small":"Rest","honka-wall-bars-birch-plywood-78cm-x-105cm":"Adventure","italian-courtyard-wooden-blocks-59-pieces-sabo-concept":"Play","italy-ancient-city-wooden-blocks-103-pieces-santa-maria-assunta-model":"Play","junior-marble-run-set":"Play","just-blocks-basic-big-160-piece-beech-plywood-block-set":"Play","just-blocks-basic-medium-68-beech-plywood-blocks-polish-natural-wooden-set":"Play","kaura-ii-cushion-for-luoto-ii-rocker-sand-150cm-x-55cm":"Adventure","kendi-quilted-playmat-cotton-safari-print":"Rest","kids-buffalo-leather-ranching-gloves-rarely-edition":"Adventure","kids-bushcraft-knife-rounded-tip-walnut-handle-7-overall":"Adventure","kids-extreme-mittens-water-buffalo-leather-rarely-edition":"Adventure","kids-travel-backpack-weewander-14-pockets":"Adventure","kids-two-tone-buffalo-leather-ranching-gloves-rarely-edition":"Adventure","large-gray-elephant-warming-pillow-cotton-plush-made-in-latvia":"Rest","lempi-floor-cushion-100cm-sand-polyester-fitwood":"Rest","little-helper-kids-broom-handcrafted-broomcorn-child-sized":"Adventure","loving-hearts-organic-cotton-baby-blanket-30-x-42-jacquard-knit":"Rest","lumo-play-canopy-vanilla":"Rest","luoto-ii-climbing-arch-birch-plywood-100-x-60-x-54-cm":"Adventure","make-way-for-ducklings-board-book-robert-mccloskey":"Rest","mellow-orange-bird-hand-toy":"Play","milan-knit-baby-blanket-organic-cotton":"Rest","mini-explorer-pack-waxed-canvas-kids-backpack-handmade-in-the-uk":"Adventure","miss-rumphius-picture-book-ages-5-8":"Rest","mobile-sunrise-pink-clouds-goose-sheeps-wool-filling":"Rest","mobile-sunset-blue-removable-goose-clouds":"Rest","moonlight-ballerina-silhouette-print-toverlux-translucent-insert":"Rest","nins-tomten-play-set-6-figures-42-loose-parts-grapat":"Play","oksa-pull-up-bar-dip-station-birch-plywood-150-kg-capacity":"Adventure","organic-cotton-knit-lion-stuffed-animal-baby-toy":"Rest","organic-cotton-knit-stuffed-animal-baby-toy-soft-plush-dino":"Rest","pebble-bento-box":"Adventure","playforever-four-car-set":"Play","pocket-flower-press-reusable-wooden-press-made-in-usa":"Adventure","quiet-journey-wooden-sailboat-play-set-32-x-9-x-16-5-cm":"Play","rallye-striped-spinning-top-large-austrian-hardwood":"Play","rings-rattle-beech-wood-natural":"Play","rocker-wedges-for-luoto-ii-climbing-arch-birch-plywood-set-of-4":"Adventure","rosewood-cottage-wooden-playhouse-16-5-x-15-75-x-12-2-tender-leaf-toys":"Play","roxaboxen-childrens-book-by-alice-mclerran-barbara-cooney-ages-4-8":"Rest","rugcycled-washable-rug-clouds-s-cotton-cloud-pattern-5-5-lb":"Rest","sea-adventure-wooden-play-set-sailboat-lighthouse-coastal-landscape-28-5-x-15-5-x-20-cm":"Play","senger-naturwelt-plush-cat-gots-cotton-sheeps-wool-6-7":"Rest","small-gray-elephant-warming-pillow-cotton-wool-senger-naturwelt":"Rest","specimen-collecting-kit":"Adventure","spinning-top-plate-25cm-maple":"Play","spinning-top-plate-25cm-walnut":"Play","stars-organic-cotton-jacquard-knit-baby-blanket-30-x-42":"Rest","the-snowy-day-picture-book-ages-2-5":"Rest","toverlux-lamp-backlight-base-for-toverlux-silhouettes":"Rest","toverlux-silhouette-spring-dance":"Rest","trees-set-thujas-linden-wood-3-piece":"Play","tuohi-ii-slide-ramp-birch-plywood-120cm":"Adventure","unimog-wooden-truck-steerable-9-8-2-figures-included":"Play","upseat-baby-floor-booster-seat-with-tray-anterior-pelvic-tilt-design":"Rest","upseat-backless-booster-car-seat-ages-4-40-120-lbs-rigid-latch-wipe-clean-polyurethane":"Rest","upseat-changing-pad-extra-large-water-resistant":"Rest","victorian-dollhouse-3-story-wooden-1-12-scale-plantoys":"Play","vogel-geluk-silhouette-honeybees-toverlux-lamp-insert":"Rest","waffle-knit-baby-blanket-36-x-36-100-cotton":"Rest","walnut-crayon-holder-12-stick-12-block-handcrafted":"Play","warming-goose-27-organic-spelt-fill-gots-cotton-made-in-latvia":"Rest","washable-animal-rug-bunny-43-x-45-cotton":"Rest","washable-cloud-rug-24-x-35-mini-dream":"Rest","washable-cotton-butterfly-rug-8-pink-shades-handcrafted":"Rest","washable-play-rug-abc-color-and-letters-round-handcrafted-in-india":"Rest","washable-rug-sea-turtle-hexagonal-shell-pattern-97-cotton":"Rest","wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed":"Play","wobbel-balance-board-original-moonstone-felt-90cm-beechwood":"Adventure","wooden-alphabet-blocks-26-cubes-4cm-a-z-made-in-ukraine":"Play","wooden-blocks-set-24-multicolored-cubes-4cm-ages-1-5":"Play","wooden-castle-blocks-41-piece-set-linden-birch":"Play","wooden-farm-barn-playset-l60-w40-h27-cm-rubberwood-acacia-or-hemlock":"Play","wooden-forest-set-10-trees-linden-or-birch-sabo-concept":"Play","wooden-horse-stable-rubber-wood-6-stalls":"Play","wooden-jeep-toy-steerable-2-figures-fagus-11":"Play","wooden-kitchen-set-15-pieces-ages-3":"Play","wooden-lighthouse-4-5-x-4-5-x-20-cm-natural-beech-linden":"Play","wooden-play-kitchen-set-14-piece-flower-print-age-3":"Play","wooden-rainbow-arch-stacker-7-pieces-linden-or-birch-10-2-x-5-1":"Play","wooden-rainbow-stacking-arches-flower-meadow-6-8-mini":"Play","wooden-ring-stacker-8-1-tall-made-in-ukraine":"Play","wooden-ring-stacker-muted-earthy-colors-4-9-x-4-9-x-8-1":"Play","wooden-ring-stacker-water-based-paint-sabo-concept-ukraine":"Play","wooden-tea-set-14-pieces-flower-linden-birch-ages-3":"Play","wooden-tea-set-19-pieces-sabo-concept":"Play","woodland-building-set-18-tubes-9-walkways-hand-painted-wooden-blocks":"Play","zwirbel-spinning-top-austrian-hardwood":"Play"};
  var MAKERS = {"Abel":"Abel","Banwood Inc.":"Banwood","Beaver Craft":"BeaverCraft","Comfy Cubs":"Comfy Cubs","Crane Baby":"Crane Baby","Cuboro":"CUBORO","Exotac":"Exotac","Fagus":"Fagus","Filana Beeswax Crayons":"Filana","Fitwood":"FitWood","Grapat":"Grapat","HarperCollins":"HarperCollins","Journeyman Handcraft":"Journeyman Handcraft","June and December":"June & December","Just Blocks":"Just Blocks","Lorena Canals":"Lorena Canals","Mader Kreiselmanufaktur":"Mader","Millstream Home":"Millstream Home","Parker Homestead":"Parker Homestead","Penguin Random House LLC":"Penguin Random House","Plan Toys":"PlanToys","Playforever":"Playforever","QToys":"QToys","Rarely":"Rarely","Sabo Concept":"Sabo Concept","Senger Naturwelt":"Senger Naturwelt","Simon Schuster":"Simon & Schuster","Tender Leaf Toys":"Tender Leaf Toys","Toverlux":"Toverlux","Upseat":"Upseat","Viverano Organics":"Viverano Organics","WeeWander":"WeeWander","Wobbel":"Wobbel","NOCS Provisions":"NOCS Provisions","Olight":"Olight","Olive and Cradle":"Olive & Cradle","Olive & Cradle":"Olive & Cradle"};

  // Entire-brand kids makers: every live SKU belongs on Rarely Young.
  var ENTIRE_BRAND = {
    "Abel": true,
    "Cuboro": true,
    "Fagus": true,
    "Grapat": true,
    "QToys": true,
    "Sabo Concept": true,
    "Plan Toys": true,
    "Tender Leaf Toys": true,
    "Just Blocks": true,
    "Mader Kreiselmanufaktur": true,
    "Filana Beeswax Crayons": true,
    "Senger Naturwelt": true,
    "Crane Baby": true,
    "Viverano Organics": true,
    "Comfy Cubs": true,
    "Toverlux": true,
    "Upseat": true,
    "Banwood Inc.": true,
    "Banwood": true,
    "Wobbel": true,
    "June and December": true,
    "June & December": true,
    "WeeWander": true,
    "Olive and Cradle": true,
    "Olive & Cradle": true,
    "TWW Wholesale": true
  };

  // Vendor → sort when the handle is not in DEPARTMENTS. Fitwood omitted (mixed).
  var VENDOR_DEPARTMENTS = {
    "Abel": "Play",
    "Cuboro": "Play",
    "Fagus": "Play",
    "Grapat": "Play",
    "QToys": "Play",
    "Sabo Concept": "Play",
    "Plan Toys": "Play",
    "Tender Leaf Toys": "Play",
    "Just Blocks": "Play",
    "Mader Kreiselmanufaktur": "Play",
    "Filana Beeswax Crayons": "Play",
    "Senger Naturwelt": "Rest",
    "Crane Baby": "Rest",
    "Viverano Organics": "Rest",
    "Comfy Cubs": "Rest",
    "Toverlux": "Rest",
    "Upseat": "Rest",
    "Lorena Canals": "Rest",
    "Millstream Home": "Rest",
    "HarperCollins": "Rest",
    "Penguin Random House LLC": "Rest",
    "Simon Schuster": "Rest",
    "Banwood Inc.": "Adventure",
    "Banwood": "Adventure",
    "Wobbel": "Adventure",
    "June and December": "Adventure",
    "June & December": "Adventure",
    "WeeWander": "Adventure",
    "Journeyman Handcraft": "Adventure",
    "Beaver Craft": "Adventure",
    "Exotac": "Adventure",
    "Rarely": "Adventure",
    "Parker Homestead": "Adventure",
    "NOCS Provisions": "Adventure",
    "Olight": "Adventure",
    "Olive and Cradle": "Rest",
    "Olive & Cradle": "Rest",
    "TWW Wholesale": "Play"
  };

  // Leftover listings still vendor-tagged TWW Wholesale (PO distributor).
  // Card maker + A–Z use the real brand; Shopify vendor stays TWW for repurchase.
  var TWW_MAKERS = {
    "3-nins-3-woods-wooden-peg-dolls": "Grapat",
    "advent-calendar-christmas-2026": "Grapat",
    "ara-figure-colored-6-colors": "Mader",
    "ballerina-figurine": "Mader",
    "container-tipper-trailer-die-cast-metal-compatible-with-bruder-trucks": "Fagus",
    "grapat-nins-rings-coins-complementary-colors-18-pieces": "Grapat",
    "grapat-ornament-set-nr-3-jingle-joy-bells": "Grapat",
    "grapat-ornament-set-nr-7-wish-balls-7-wooden-ornaments": "Grapat",
    "grapat-ornament-set-nr-8-kind-folks-wooden-figures": "Grapat",
    "grapat-play-set-forest-trees": "Grapat",
    "grapat-pure-shine-ornament-set-no-9": "Grapat",
    "grapat-winter-sparkles-ornament-set-no-6-wooden-loose-parts": "Grapat",
    "ibis-plush-soft-velour-body-hand-embroidered-face": "Mader",
    "kick-marble-run-extra-set-add-on-track-pieces": "Cuboro",
    "mandala-natural-wood-stacking-toy": "Grapat",
    "moonlight-tale-play-set-wooden-figurines": "Grapat",
    "nonna-doll": "Mader",
    "paper-snowflake-cutting-kit-mandala-patterns": "Grapat",
    "semi-trailer": "Fagus",
    "skip-truck-solid-beech-wood-push-toy": "Fagus",
    "speed-marble-run-extra-set-expansion-pack": "Cuboro",
    "spinning-plate-25cm-black-oak": "Mader",
    "striped-straw-hat": "Mader",
    "striped-top-large": "Mader",
    "striped-top-small": "Mader",
    "the-pendulum-balance-toy-wooden-stacking-equilibrium-puzzle": "Grapat",
    "trick-marble-run-extra-set": "Cuboro",
    "ufo-flora-vase-6-colors": "Mader",
    "wooden-tractor-classic": "Fagus"
  };

  var STORE = '';

  function hasTag(p, tag) {
    var t = p.tags || [];
    if (typeof t === 'string') {
      return t.split(',').map(function (s) { return s.trim(); }).indexOf(tag) !== -1;
    }
    return t.indexOf(tag) !== -1;
  }
  function hasKidsTag(p) { return hasTag(p, 'kids'); }
  function isEntireBrand(vendor) {
    if (!vendor) return false;
    if (ENTIRE_BRAND[vendor]) return true;
    var maker = MAKERS[vendor];
    return !!(maker && ENTIRE_BRAND[maker]);
  }
  function belongsToRarelyYoung(p) {
    return !!(DEPARTMENTS[p.handle] || hasKidsTag(p) || isEntireBrand(p.vendor));
  }
  function classifyDepartment(p) {
    if (p.handle && DEPARTMENTS[p.handle]) return DEPARTMENTS[p.handle];
    var vendor = p.vendor || '';
    if (VENDOR_DEPARTMENTS[vendor]) return VENDOR_DEPARTMENTS[vendor];
    var maker = MAKERS[vendor];
    if (maker && VENDOR_DEPARTMENTS[maker]) return VENDOR_DEPARTMENTS[maker];
    return 'Unsorted';
  }
  function makerFor(p) {
    if (p && p.handle && TWW_MAKERS[p.handle]) {
      var mapped = TWW_MAKERS[p.handle];
      return MAKERS[mapped] || mapped;
    }
    var vendor = (p && p.vendor) || '';
    return MAKERS[vendor] || vendor;
  }
  function cardTitle(title, maker, vendor) {
    var full = String(title || '');
    if (!maker || maker === vendor) return full;
    if (full.toLowerCase().indexOf(String(maker).toLowerCase()) !== -1) return full;
    return maker + ' ' + full;
  }
  // Sorted Rarely Young pages: A–Z by maker, then like products, heroes
  // before add-ons. Cuboro then price high → low. Other brands then
  // smaller to larger, then name. groupByBrand is unused in the live
  // grid (seamless cards) but kept so maker headings can be restored.
  function brandLabel(p) {
    return String(p.maker || p.vendor || 'Other').trim() || 'Other';
  }
  function productBlob(p) {
    return [p.handle, p.name, p.full, p.productType]
      .map(function (s) { return String(s || '').toLowerCase(); })
      .join(' ');
  }
  function blobHas(blob, words) {
    for (var i = 0; i < words.length; i++) {
      if (blob.indexOf(words[i]) !== -1) return true;
    }
    return false;
  }
  function genericFamily(blob) {
    var rules = [
      ['nins', ['nins']],
      ['ornament', ['ornament']],
      ['mandala', ['mandala']],
      ['rattle', ['rattle']],
      ['tea-set', ['tea set', 'tea-set']],
      ['kitchen', ['kitchen']],
      ['castle', ['castle', 'kingdom', 'courtyard', 'ancient city']],
      ['stacker', ['stacker', 'rainbow']],
      ['boat', ['sailboat', 'boat', 'ship']],
      ['dollhouse', ['dollhouse', 'doll house', 'dolls house', 'playhouse']],
      ['blocks', ['block']],
      ['goose', ['goose']],
      ['elephant', ['elephant']],
      ['rabbit', ['rabbit', 'bunny']],
      ['mobile', ['mobile']]
    ];
    for (var i = 0; i < rules.length; i++) {
      if (blobHas(blob, rules[i][1])) return rules[i][0];
    }
    return 'other';
  }
  // rank 0 = primary family, 1 = accessory family, 5 = generic like-group, 9 = leftover.
  // role 0 = hero, 1 = add-on, 2 = unranked.
  function productFamily(p) {
    var maker = brandLabel(p).toLowerCase();
    var blob = productBlob(p);
    var handle = String(p.handle || '').toLowerCase();
    var type = String(p.productType || '').toLowerCase();
    if (maker === 'mader') {
      if (blobHas(blob, ['plate'])) return { family: 'plates', rank: 1, role: 1 };
      return { family: 'tops', rank: 0, role: 0 };
    }
    if (maker === 'fagus') {
      if (blobHas(blob, ['trailer', 'farm cart', 'farm-cart'])) return { family: 'trailers', rank: 1, role: 1 };
      return { family: 'vehicles', rank: 0, role: 0 };
    }
    if (maker === 'cuboro') {
      if (handle === 'marbles-for-marble-run' || handle === 'cuboro-the-book-for-marble-runs' || handle.indexOf('extra-set') !== -1) {
        return { family: 'marble-run', rank: 0, role: 1 };
      }
      return { family: 'marble-run', rank: 0, role: 0 };
    }
    if (maker === 'plantoys' || maker === 'tender leaf toys') {
      var houseAddon = type.indexOf('accessor') !== -1 ||
        blobHas(blob, ['furniture', 'bathroom', 'bedroom', 'dining', 'nursery set', 'greenhouse']);
      var namedHouse = blobHas(blob, [
        'victorian-dollhouse', 'grand-victorian', 'my-first-doll', 'slide-n-go', 'slide n go',
        'cottontail-cottage', 'rosewood-cottage', 'classic-wooden-dollhouse'
      ]);
      if (houseAddon && !namedHouse) return { family: 'dollhouse', rank: 0, role: 1 };
      return { family: 'dollhouse', rank: 0, role: 0 };
    }
    if (maker === 'banwood') {
      if (blobHas(blob, ['helmet', 'protective', 'basket', 'pins'])) return { family: 'ride', rank: 0, role: 1 };
      return { family: 'ride', rank: 0, role: 0 };
    }
    if (maker === 'fitwood') {
      if (blobHas(blob, ['cushion', 'felt pad', 'felt-pads', 'wedge', 'canopy'])) return { family: 'climb', rank: 0, role: 1 };
      return { family: 'climb', rank: 0, role: 0 };
    }
    return { family: genericFamily(blob), rank: 5, role: 2 };
  }
  var SIZE_MISSING = 1e9;
  function sizeBlob(p) {
    return productBlob(p)
      .replace(/1[:\-]12\s*scale/g, ' ')
      .replace(/\bages?\s*\d+(?:\s*[-–]\s*\d+)?/g, ' ')
      .replace(/\b\d+\s*[-–]\s*\d+\s*years\b/g, ' ');
  }
  function sizeNumber(blob, re) {
    var m = blob.match(re);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return isFinite(n) ? n : null;
  }
  function sizeWord(blob) {
    if (/\bmini\b/.test(blob)) return 10;
    if (/\bpocket\b/.test(blob)) return 15;
    if (/\bjunior\b/.test(blob)) return 20;
    if (/\bsmall\b/.test(blob)) return 30;
    if (/\bmedium\b/.test(blob)) return 45;
    if (/\blarge\b/.test(blob)) return 70;
    if (/\bmaxi\b/.test(blob)) return 75;
    if (/\bbig\b/.test(blob)) return 80;
    if (/\bgrand\b/.test(blob)) return 90;
    if (/\bxl\b/.test(blob)) return 95;
    return 50;
  }
  function sizePieces(blob) {
    var n = sizeNumber(blob, /(\d+)\s*[-]?\s*(?:piece|pieces|pcs)\b/);
    if (n != null) return n;
    n = sizeNumber(blob, /(?:mini|blocks|standard|basic)\s+(\d+)\b/);
    if (n != null) return n;
    return sizeNumber(blob, /(\d+)\s+beech\b/);
  }
  // Smaller → larger after family/hero. Missing numeric size sorts last
  // so 12" / 16" / piece counts beat unlabeled names.
  function sizeKey(p) {
    var blob = sizeBlob(p);
    var inch = sizeNumber(blob, /(\d+(?:\.\d+)?)\s*(?:"|”|inch(?:es)?\b)/);
    var cm = sizeNumber(blob, /(\d+(?:\.\d+)?)\s*cm\b/);
    var pieces = sizePieces(blob);
    var levels = sizeNumber(blob, /(\d+)\s*[-]?\s*(?:stor(?:y|ies)|floor|floors)\b/);
    return {
      word: sizeWord(blob),
      inch: inch == null ? SIZE_MISSING : inch,
      cm: cm == null ? SIZE_MISSING : cm,
      pieces: pieces == null ? SIZE_MISSING : pieces,
      levels: levels == null ? SIZE_MISSING : levels
    };
  }
  function cmpSize(a, b) {
    var as = sizeKey(a);
    var bs = sizeKey(b);
    if (as.word !== bs.word) return as.word - bs.word;
    if (as.inch !== bs.inch) return as.inch - bs.inch;
    if (as.cm !== bs.cm) return as.cm - bs.cm;
    if (as.pieces !== bs.pieces) return as.pieces - bs.pieces;
    if (as.levels !== bs.levels) return as.levels - bs.levels;
    return 0;
  }
  function sortByBrand(list) {
    return list.slice().sort(function (a, b) {
      var am = brandLabel(a).toLowerCase();
      var bm = brandLabel(b).toLowerCase();
      if (am < bm) return -1;
      if (am > bm) return 1;
      var af = productFamily(a);
      var bf = productFamily(b);
      if (af.rank !== bf.rank) return af.rank - bf.rank;
      if (af.family < bf.family) return -1;
      if (af.family > bf.family) return 1;
      if (af.role !== bf.role) return af.role - bf.role;
      if (am === 'cuboro' && bm === 'cuboro') {
        var pa = Number(a.price);
        var pb = Number(b.price);
        if (isFinite(pa) && isFinite(pb) && pa !== pb) return pb - pa;
      }
      var size = cmpSize(a, b);
      if (size) return size;
      var an = String(a.name || a.full || '').toLowerCase();
      var bn = String(b.name || b.full || '').toLowerCase();
      if (an < bn) return -1;
      if (an > bn) return 1;
      return String(a.handle || '').localeCompare(String(b.handle || ''));
    });
  }
  function groupByBrand(list) {
    var groups = [];
    var last = null;
    sortByBrand(list).forEach(function (p) {
      var key = brandLabel(p);
      if (!last || last.key.toLowerCase() !== key.toLowerCase()) {
        last = { key: key, items: [] };
        groups.push(last);
      }
      last.items.push(p);
    });
    return groups;
  }
  function money(v) { return v == null ? null : Number(v); }
  function shortName(title, vendor, maker) {
    var name = title.split('|')[0].trim();
    var prefixes = [maker, vendor];
    for (var i = 0; i < prefixes.length; i++) {
      var pref = prefixes[i];
      if (pref && name.toLowerCase().indexOf(pref.toLowerCase() + ' ') === 0) { name = name.slice(pref.length).trim(); break; }
    }
    return name || title;
  }
  function imageUrl(src, width) {
    if (!src) return null;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function plainText(html) {
    return String(html || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&#39;|&rsquo;/g, '\u2019').replace(/&quot;/g, '"').replace(/\s+/g, ' ').trim();
  }
  function normalize(p) {
    var maker = makerFor(p);
    var variants = p.variants || [];
    var prices = variants.map(function (v) { return money(v.price); }).filter(function (n) { return n != null; });
    var compare = variants.map(function (v) { return money(v.compare_at_price); }).filter(function (n) { return n != null; });
    var primary = p.images && p.images[0] ? p.images[0].src : null;
    return {
      id: p.id, handle: p.handle, maker: maker, vendor: p.vendor,
      name: shortName(p.title, p.vendor, maker), full: cardTitle(p.title, maker, p.vendor),
      url: STORE + '/products/' + p.handle,
      department: classifyDepartment(p),
      christmas: hasTag(p, 'christmas'),
      img: imageUrl(primary, 900), thumb: imageUrl(primary, 400),
      price: prices.length ? Math.min.apply(null, prices) : null,
      priceMax: prices.length ? Math.max.apply(null, prices) : null,
      compareAtPrice: compare.length ? Math.max.apply(null, compare) : null,
      available: variants.some(function (v) { return v.available; }),
      desc: plainText(p.body_html).slice(0, 220),
      productType: p.product_type || '', tags: p.tags || []
    };
  }
  function fetchPage(page) {
    return fetch(STORE + '/products.json?limit=250&page=' + page, { headers: { accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('products.json HTTP ' + r.status); return r.json(); })
      .then(function (d) { return d.products || []; });
  }
  // Pages are fetched in parallel (the store is ~3 pages of 250) and the normalized
  // result is kept in sessionStorage for a few minutes so moving between Rarely
  // Young pages is instant.
  var CACHE_KEY = 'rarely-young-products-v6', CACHE_TTL = 10 * 60 * 1000, FIRST_BATCH = 4;
  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY); if (!raw) return null;
      var c = JSON.parse(raw); if (!c || Date.now() - c.t > CACHE_TTL) return null;
      return c.products;
    } catch (e) { return null; }
  }
  function writeCache(products) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), products: products })); } catch (e) {}
  }
  function fetchAll(from, acc) {
    var pages = [];
    for (var i = 0; i < FIRST_BATCH; i++) pages.push(fetchPage(from + i));
    return Promise.all(pages).then(function (results) {
      var got = [].concat.apply([], results); acc = acc.concat(got);
      var last = results[results.length - 1];
      if (last.length === 250 && from + FIRST_BATCH <= 20) return fetchAll(from + FIRST_BATCH, acc);
      return acc;
    });
  }
  function loadProducts() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    return fetchAll(1, []).then(function (live) {
      var products = live.filter(belongsToRarelyYoung).map(normalize);
      writeCache(products);
      return products;
    });
  }
  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  return {
    loadProducts: loadProducts,
    escHtml: escHtml,
    departments: DEPARTMENTS,
    makers: MAKERS,
    vendorDepartments: VENDOR_DEPARTMENTS,
    entireBrand: ENTIRE_BRAND,
    classifyDepartment: classifyDepartment,
    belongsToRarelyYoung: belongsToRarelyYoung,
    makerFor: makerFor,
    cardTitle: cardTitle,
    brandLabel: brandLabel,
    sortByBrand: sortByBrand,
    groupByBrand: groupByBrand
  };
})();
